<mat-card appearance="outlined">
  <mat-card-title>Accueil</mat-card-title>
  @if (isLoading) {
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  }
  @if (!isLoading) {
    <div>
      <div>
        <p class="small_size">Raison sociale</p>
        <p class="upper_margin"> {{ businessName }} </p>
      </div>
      @if (tiers !== '') {
        <div>
          <p class="small_size">Code client</p>
          <p class="upper_margin"> {{ tiers }} </p>
        </div>
      }
      @if (siret !== '') {
        <div>
          <p class="small_size">SIRET</p>
          <p class="upper_margin"> {{ siret }} </p>
        </div>
      }
      <div>
        <p class="small_size">Ville</p>
        <p class="upper_margin"> {{ city }} </p>
      </div>
      <mat-divider></mat-divider>
      @if (customerContact !== null) {
        <div>
          <p class="small_size">Responsable client</p>
          <p class="upper_margin"> {{ customerContact }} </p>
        </div>
      }
      @if (emailContact !== null) {
        <div>
          <p class="small_size">Email responsable client</p>
          <p class="upper_margin"> {{ emailContact }} </p>
        </div>
      }
      @if (telephone !== null) {
        <div>
          <p class="small_size">Téléphone responsable client</p>
          <p class="upper_margin">{{ telephone }}</p>
        </div>
      }
      <div>
        <p class="small_size">Agence</p>
        <p class="upper_margin"> {{ agency }} </p>
      </div>
    </div>
  }
</mat-card>
